function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.553,
    height: 16,
    viewBox: "0 0 13.553 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56982",
    d: "M44.516 2.053c-.1 0-.2.006-.287 0a1.054 1.054 0 0 1-.953-.878 1.046 1.046 0 0 1 .69-1.147.587.587 0 0 1 .206-.037c1.037 0 2.078-.019 3.115 0A1.036 1.036 0 0 1 48.306 1a1.073 1.073 0 0 1-1.012 1.053c-.075 0-.15.016-.244.025 0 .131-.006.256 0 .378a.146.146 0 0 0 .091.1 7.292 7.292 0 0 1 2.8 1.272.111.111 0 0 0 .031.006c.222-.212.447-.437.684-.647a.816.816 0 0 1 1.206 1.09c-.178.222-.375.425-.572.628a.213.213 0 0 0-.019.319 6.777 6.777 0 1 1-12.1 5.442 6.614 6.614 0 0 1-.066-.341 6.789 6.789 0 0 1 4.946-7.675c.028-.006.056-.016.084-.022.406-.109.406-.109.381-.575zm6.252 7.158A4.963 4.963 0 0 0 45.791 4.2a5 5 0 1 0 4.977 5.008z",
    transform: "translate(-39.005 .019)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 56983",
    d: "m231.527 193.521 2.318-2.318a.446.446 0 1 0-.619-.644l-.012.012-2.314 2.319a.829.829 0 1 0 .631.987.762.762 0 0 0-.004-.356z",
    transform: "translate(-223.926 -184.485)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.0d88ed806574d699ba606d655dc34a59.svg";
export { ForwardRef as ReactComponent };